import { useState, useEffect } from 'react';
import { RefreshCw, X } from 'lucide-react';

// Viser en diskret toast når en ny versjon av FiskDa er klar.
// Lytter på 'fiskda:sw-update' fra service worker-registreringen.
export default function UpdateToast() {
  const [show, setShow] = useState(false);
  const [activateFn, setActivateFn] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setActivateFn(() => e.detail?.activate);
      setShow(true);
    };
    window.addEventListener('fiskda:sw-update', handler);
    return () => window.removeEventListener('fiskda:sw-update', handler);
  }, []);

  if (!show) return null;

  const handleUpdate = () => {
    if (activateFn) activateFn();
    // controllerchange i registreringen laster siden på nytt
  };

  return (
    <div className="fixed left-4 right-4 z-[320] install-prompt" style={{ top: 'calc(env(safe-area-inset-top) + 5rem)' }}>
      <div className="bg-[#3B4D3C] text-[#F8F5F0] rounded-lg shadow-2xl p-4 flex items-center gap-4 max-w-md mx-auto">
        <div className="bg-[#F8F5F0]/15 p-2.5 rounded shrink-0">
          <RefreshCw size={20} className="text-[#F8F5F0]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-sans text-sm font-semibold">Ny versjon tilgjengelig</p>
          <p className="font-sans text-xs text-[#F8F5F0]/70">
            Oppdater for å få de nyeste forbedringene
          </p>
        </div>
        <button
          onClick={handleUpdate}
          className="px-4 py-2 bg-[#E67E22] text-[#F8F5F0] rounded font-sans text-xs font-semibold shrink-0 active:scale-95 transition-transform"
        >
          Oppdater
        </button>
        <button
          onClick={() => setShow(false)}
          className="p-1 text-[#F8F5F0]/50 hover:text-[#F8F5F0] shrink-0 transition-colors"
          aria-label="Lukk"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
